import AdminPageLoader from "components/AdminPageLoader";
import { useState } from "react";
import { FiSearch } from "react-icons/fi";
import { portalPageMeta } from "layouts/Admin2/pageMeta";
import PageHeading from "admin/components/PageHeading";
import useFetchPublishers from "api/PublisherResource/useFetchPublishers";
import Admin2 from "layouts/Admin2";
import moment from "moment";
import { Column } from "primereact/column";
import { DataTable } from "components/PortalDataTable";
import MoreAboutPublisher from "./MoreAboutPublisher";
import DeletePublisher from "./DeletePublisher";
import PublisherStatus from "./PublisherStatus";

const Publishers = () => {
    const [search, setSearch] = useState("");
	const { data, isLoading } = useFetchPublishers({
		withUsers: true,
	});

	const publishers = data?.data;

	const totalRecords = data?.data?.length || 0;

	const canUseRatePricingTemplate = (row) => {
		return row.use_rate_pricing ? (
			<span className="flex justify-center items-center  bg-akgreenest text-white w-10 rounded-full">
				Yes
			</span>
		) : (
			<span className="flex justify-center items-center border border-akgreener text-akgreener w-10 rounded-full ">
				No
			</span>
		);
	};

	const createdAtTemplate = (row) =>
		moment(row.created_at).format("MMM DD, YYYY");

	const actionBodyTemplate = (row) => (
		<div className="flex justify-center items-center gap-3">
			<MoreAboutPublisher
				publisher={row}
				facilitators={row?.facilitators}
			/>
			<DeletePublisher
				publisherId={row.id}
				publisherName={row?.name}
			/>
		</div>
	);

	const statusTemplate = (row) => {
		return (
			<PublisherStatus
				status={row?.status}
				publisherId={row?.id}
			/>
		);
	};

	if (isLoading) return <AdminPageLoader />;

	return (
		<Admin2>
			<div className="portal-page-container">
				<PageHeading title="Publishers" description={portalPageMeta("/publishers").description} count={totalRecords} />
                <div className="portal-filter-bar"><label className="portal-inline-search"><FiSearch aria-hidden="true" /><input type="search" aria-label="Search publishers" placeholder="Search publishers…" value={search} onChange={(event) => setSearch(event.target.value)} /></label></div>
				<DataTable
					value={publishers}
                    globalFilter={search}
                    globalFilterFields={["name"]}
                    emptyMessage="No publishers match your search."
					dataKey="id"
					tableClassName="font-sans text-sm"
					autoLayout
				>
					<Column
						field="name"
						header="Name"
						sortable
					/>
					<Column
						header="Date registered"
						body={createdAtTemplate}
					/>
					<Column
						header="Uses rate pricing"
						body={canUseRatePricingTemplate}
					/>
					<Column
						header="Approval status"
						bodyClassName="text-center"
						body={statusTemplate}
					/>
					<Column
						header="Actions"
						body={actionBodyTemplate}
					/>
				</DataTable>
			</div>
		</Admin2>
	);
};

export default Publishers;
